<ng-container *transloco="let t">
@if (agent) {
  <div class="border border-gray-300 border-dashed rounded py-0 px-4 mt-2 pt-xs-5 mobile-profile-container">
    <div class="row">
      <div class="col-md-4 d-flex align-items-center justify-content-center">
        <person-circle-image [url]="agent.agentAvatarUrl" [size]="60"></person-circle-image>
      </div>
      <div class="col-md-8 p-2 text-xs-center">
        @if (!!agent.firstName || !!agent.lastName) {
          <span class="mb-1">
            {{agent?.firstName }}
            {{ agent?.lastName }}
          </span>
        }
        @if (agent.agentNMLS || agent.companyNMLS) {
          <p class="mb-0 text-xs-center">
            <small>
              {{ t('portal.agentContact.nmls') }} {{agent.agentNMLS || agent.companyNMLS}}
            </small>
          </p>
        }
        @if (agent.role) {
          <p class="mb-0 text-xs-center">
            <small>{{ t('portal.agentContact.role') }} {{agent.role}}</small>
          </p>
        }
      </div>
    </div>
    <div class="row text-xs-center">
      <div class="d-flex flex-column">
        @if (agent.phoneNumber) {
          <a class="nav-link d-inline pb-0" href="tel:{{ agent.phoneNumber }}">
            <i class="fa fa-phone me-2 display-unset"></i>{{ agent.phoneNumber | phone }}
          </a>
        }
        @if (agent.emailAddress) {
          <a class="nav-link d-inline pb-0" href="mailto: {{ agent.emailAddress }}">
            <i class="fa fa-envelope me-2 display-unset"></i>{{ agent.emailAddress }}
          </a>
        }
        <div class="d-flex justify-content-{{agent.calendarLink ? 'between' : 'start'}}">
          @if (agent.calendarLink) {
            <a class="nav-link d-inline pb-0" [href]="agent.calendarLink" target="_blank"> <i
                class="fa fa-calendar me-2 display-unset"></i> {{ t('portal.agentContact.viewCalendar') }}
            </a>
          }
          <a class="nav-link d-inline pb-0" (click)="onAgentNameClicked()" target="_blank" [title]="t('portal.agentContact.requestCallTitle')"><i
            class="fa fa-user me-2 display-unset"></i> {{ t('portal.agentContact.contact') }}
          </a>
        </div>
      </div>
      @if (!agentAddressHidden) {
        <div class="opacity-80 d-flex align-items-center ps-7">
          <i class="fas fa-map-marker-alt me-2"></i>
          <span>
            {{ agent.address || t('portal.agentContact.noStreetAddress') }}
            @if (agent.city || agent.state || agent.zip) {
              <span>
                {{agent.city ? agent.city + "," : ""}}{{ agent.state }}{{ agent.zip }}
              </span>
            }
          </span>
        </div>
      }
    </div>
  </div>
}
</ng-container>
